"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_i18next_1 = require("react-i18next");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var useIsBellActive_1 = __importDefault(require("./hooks/useIsBellActive"));
var prism_icons_1 = require("@octanner/prism-icons");
var styles_1 = require("./styles");
var NotificationBell = function (_a) {
    var props = __rest(_a, []);
    var t = (0, react_i18next_1.useTranslation)().t;
    var isActive = (0, useIsBellActive_1.default)().isActive;
    return (react_1.default.createElement(Tooltip_1.default, { title: t('prism-header:notifications', 'Notifications'), placement: "bottom" },
        react_1.default.createElement(material_1.IconButton, __assign({}, props, { "data-testid": "notification-icon", component: "a", href: "/notifications", "aria-label": !isActive
                ? t('prism-header:notifications', 'Notifications')
                : t('prism-header:new-notifications', 'New Notifications'), sx: styles_1.iconButtonOverride }),
            react_1.default.createElement(material_1.Badge, { invisible: !isActive, variant: "dot", color: "error" },
                react_1.default.createElement(prism_icons_1.Notification, null)))));
};
exports.default = NotificationBell;
//# sourceMappingURL=NotificationBell.js.map